import React from 'react';
import styled from 'styled-components';

import useSharedRef from '../../hooks/useSharedRef';
import calculateHeaderHeight from './calculateHeaderHeight';

export const StyledScrollIntoViewContainer = styled.div`
  min-height: ${({ headerHeight }) => `calc(100vh - ${headerHeight}px)`};
`;

const ScrollIntoViewContainer = (props) => {
  const { refs } = useSharedRef();

  const headerHeight = calculateHeaderHeight(refs);

  return React.createElement(StyledScrollIntoViewContainer, {
    headerHeight,
    ...props,
  });
};

export default ScrollIntoViewContainer;
